// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"mainWrapper__23DR4","centralWrapper":"centralWrapper__1ZJoM","rightColumn":"rightColumn__2sI_N","leftColumn":"leftColumn__1AdJ8"};